import { render, staticRenderFns } from "./DatasetInfoIcon.vue?vue&type=template&id=760ff391&scoped=true"
import script from "./DatasetInfoIcon.vue?vue&type=script&lang=js"
export * from "./DatasetInfoIcon.vue?vue&type=script&lang=js"
import style0 from "./DatasetInfoIcon.vue?vue&type=style&index=0&id=760ff391&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760ff391",
  null
  
)

export default component.exports